export default {
  origin: null,
  init(): void {
    this.origin = window.location.origin;
  },
};
